import VConsole from "vconsole";
import application from "./application.js";

let vConsole = null;

if (application.debug === true) {
    vConsole = new VConsole();
}

export default vConsole;